export default {
  search_name: '',
  weight_lower: '',
  weight_upper: '',
  bmi_lower: '',
  bmi_upper: '',
  body_fat_rate_lower: '',
  body_fat_rate_upper: '',
  compare_weight_lower: '',
  compare_weight_upper: '',
  compare_BodyFatRate_lower: '',
  compare_BodyFatRate_upper: '',
  admin_note: '',
  member_status: '',
  last_measure_at_from: '',
  last_measure_at_to: '',
  created_at_from: '',
  created_at_to: '',
  member_answer1: '',
  member_answer2: '',
  member_answer3: '',
  member_answer4: '',
}
